<template>
    <tab-layout>
        <template slot="content">
            <!-- RIB -->
            <h2 class="m-0">
                {{ $l10n.__('Compte(s) bancaire(s)') }}
                <CompassButton
                    v-if="hasAccess('can_edit_rib', permissions)"
                    :label="$t.__('common.actions.add_bank_account')"
                    class="fright"
                    @click="goToAddAccount"
                />
            </h2>
            <div class="prelative">
                <preloader :display="loading" />
                <div v-if="!loading">
                    <ul v-if="banksaccounts.length > 0">
                        <li
                            v-for="(banksaccount, banksaccountIndex) in banksaccounts"
                            :key="banksaccountIndex"
                            class="well mb-2 account-card relative"
                            :id="`bankaccount_${banksaccount.id}`"
                        >
                            <h4 class="mt-0">
                                {{ banksaccount.label }}
                                <span v-if="banksaccount.rank == 0">(Compte par défaut)</span>
                            </h4>
                            <div v-if="banksaccount.hasiban">
                                <p>
                                    {{ $l10n.__('BIC') }} :
                                    <span class="bold">{{
                                        banksaccount.bic != '' ? banksaccount.bic : '-'
                                    }}</span>
                                </p>
                                <p>
                                    {{ $l10n.__('IBAN') }} :
                                    <span class="bold">{{
                                        banksaccount.iban != '' ? banksaccount.iban : '-'
                                    }}</span>
                                </p>
                                <p>
                                    {{ $l10n.__('SEPA') }} :
                                    <span class="bold">{{
                                        banksaccount.sepa != '' ? banksaccount.sepa : '-'
                                    }}</span>
                                </p>
                                <p>
                                    {{ $l10n.__('Mandat') }} :
                                    <span class="bold">{{
                                        banksaccount.mandat != '0000-00-00'
                                            ? banksaccount.mandat
                                            : '-'
                                    }}</span>
                                </p>
                            </div>
                            <div v-else>
                                <p>
                                    {{ $l10n.__('Nom du compte') }} :
                                    <span class="bold">{{
                                        banksaccount.name != '' ? banksaccount.name : '-'
                                    }}</span>
                                </p>
                                <p>
                                    {{ $l10n.__('N° de compte') }} :
                                    <span class="bold">{{
                                        banksaccount.number != '' ? banksaccount.number : '-'
                                    }}</span>
                                </p>
                                <p>
                                    {{ $l10n.__('Routing') }} :
                                    <span class="bold">{{
                                        banksaccount.rounting != '' ? banksaccount.rounting : '-'
                                    }}</span>
                                </p>
                                <p>
                                    {{ $l10n.__('SWIFT') }} :
                                    <span class="bold">{{
                                        banksaccount.swift != '' ? banksaccount.swift : '-'
                                    }}</span>
                                </p>
                            </div>

                            <el-dropdown
                                v-if="hasAccess('can_edit_rib', permissions)"
                                placement="bottom-end"
                                class="absolute top-right-2"
                            >
                                <i class="icon-burger"></i>

                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item
                                        v-for="(action, index) in banksaccount.actions"
                                        :key="index"
                                        :disabled="!hasAccess(action.permission, permissions)"
                                        :class="
                                            hasAccess(action.permission, permissions)
                                                ? ''
                                                : 'link-disabled'
                                        "
                                    >
                                        <a
                                            v-if="action.type == 'vuejs'"
                                            :class="
                                                !hasAccess(action.permission, permissions) ||
                                                !checkMoreAccess(banksaccount, action)
                                                    ? 'link-disabled'
                                                    : ''
                                            "
                                            @click="switchAction(action, banksaccount)"
                                        >
                                            {{ action.label }}
                                        </a>
                                        <a
                                            v-else
                                            :href="action.value"
                                            :class="
                                                !hasAccess(action.permission, permissions) ||
                                                !checkMoreAccess(banksaccount, action)
                                                    ? 'link-disabled'
                                                    : ''
                                            "
                                        >
                                            {{ action.label }}
                                        </a>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </li>
                    </ul>
                    <div v-else class="well mt-3">
                        {{ $l10n.__('Il n’y a aucun compte bancaire pour le moment') }}
                    </div>
                </div>
            </div>

            <!-- CARD -->
            <div class="mt-3">
                <h2 class="m-0">
                    {{ $l10n.__('Carte bancaire') }}
                    <CompassButton
                        v-if="!isArchived && hasAccess('can_add_card', permissions)"
                        id="stripe-btn"
                        :label="$t.__('common.actions.add_bank_card')"
                        class="fright"
                        @click="toggleStripePopup"
                    />
                </h2>
                <div class="mt-3 prelative min-h-100">
                    <preloader :display="loading" />
                    <div v-if="!loading">
                        <el-table
                            v-if="cards.length > 0"
                            class="mt-3"
                            :data="cards"
                            style="width: 100%"
                        >
                            <el-table-column
                                prop="cardType"
                                :label="$t.__('overview.tabs.TabAccountCreditCard.card')"
                            >
                                <template slot-scope="scope">
                                    {{ scope.row.cardType | capitalize }} ***-{{ scope.row.last4 }}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="expireDate"
                                :label="$t.__('overview.tabs.TabAccountCreditCard.expiration_date')"
                                width="120"
                            >
                            </el-table-column>
                            <el-table-column width="40">
                                <template slot-scope="scope">
                                    <a
                                        v-if="hasAccess('can_delete_card', permissions)"
                                        :href="`javascript:Third.deleteCardRequest('${scope.row.customerid}')`"
                                    >
                                        <i class="icon-trash cpointer hover-primary-50"></i>
                                    </a>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div v-else class="well">
                            {{ $l10n.__('Il n’y a aucune carte bancaire pour le moment') }}
                        </div>
                    </div>
                </div>
            </div>

            <stripe-form
                v-if="displayStripePopup"
                @close="toggleStripePopup"
                @save-card="saveCard"
                :thirdid="linkedid"
            />
        </template>
    </tab-layout>
</template>

<script>
import { goToUrl } from 'vueDir/helpers.js';
import OverviewTabMixin from './OverviewTabMixin';
import { buildUrl, formatActions, hasAccess } from '../../../helpers';
import { bankActions } from './mapping/ThirdMapping';
import StripeForm from '../../forms/StripeForm.vue';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import TabLayout from 'vcomponents/overview/tabs/TabLayout.vue';

export default {
    components: {
        Preloader,
        TabLayout,
        'stripe-form': StripeForm,
    },
    mixins: [OverviewTabMixin],

    data() {
        return {
            loading: true,
            permissions: {},
            banksaccounts: [],
            cards: [],
            actions: bankActions,
            displayStripePopup: false,
        };
    },

    computed: {
        routes() {
            return this.$store.getters.routes;
        },
        informations() {
            return this.$store.getters.dataFetch;
        },
        isArchived() {
            return this.informations.identity.isArchived;
        },
    },

    created() {
        this.fetch();
    },

    methods: {
        buildUrl,
        hasAccess,
        formatActions,
        fetch() {
            let route = this.routes.find((route) => route.id == 'bank');
            this.$ajax.get(
                buildUrl(route.value, [{ key: 'id', value: this.$store.getters.linkedid }]),
                {},
                (response) => {
                    this.permissions = response.permissions;
                    this.cards = response.cards;
                    if (response.banksaccounts.length > 0) {
                        let i = 0;
                        response.banksaccounts.map((bankaccount) => {
                            bankaccount.rank = i;
                            bankaccount.actions = this.setActions(bankaccount);
                            this.banksaccounts.push(bankaccount);
                            i++;
                        });
                    }
                    this.loading = false;
                    this.stripeHash = response.stripeHash;
                },
            );
        },

        setActions(bankaccount) {
            let bankParameters = [
                {
                    key: 'baid',
                    value: bankaccount.id,
                },
                {
                    key: 'thirdid',
                    value: this.$store.getters.linkedid,
                },
            ];
            return this.formatActions(this.actions, bankaccount, bankParameters);
        },
        toggleStripePopup() {
            this.displayStripePopup = !this.displayStripePopup;
        },
        switchAction(action, data) {
            switch (action.link) {
                case 'defineMainAccount':
                    this.defineMainAccount(data);
                    break;
            }
        },
        defineMainAccount(account) {
            this.$ajax.put(
                `/rest/${this.linkedtype}s/${this.linkedid}/bankaccounts/main`,
                {},
                { account: account.id },
                (response) => {
                    this.setMainAccount(account);
                },
                (error) => {
                    Push.error(
                        this.$l10n.__(
                            "Une erreur s'est produite lors de la sauvegarde du compte principal",
                        ),
                        false,
                    );
                },
            );
        },
        setMainAccount(mainAccount) {
            this.banksaccounts.map((bankaccount) => {
                bankaccount.id == mainAccount.id ? (bankaccount.rank = 0) : (bankaccount.rank = 1);
            });
        },
        checkMoreAccess(bankaccount, action) {
            if (action.id == 'defineMainAccount' && bankaccount.rank == 0) {
                return false;
            }
            return true;
        },
        saveCard(card) {
            this.$ajax.post(
                `/rest/stripe/setupintent/save/${this.linkedid}`,
                {},
                card.setupIntent,
                (response) => {
                    this.cards = [response];
                    this.toggleStripePopup();
                },
                (error) => {
                    Push.error(
                        this.$l10n.__(
                            "Une erreur s'est produite lors de la sauvegarde de la carte.",
                        ),
                        false,
                    );
                },
            );
        },
        goToAddAccount() {
            return goToUrl(`javascript:BankAccount.edit('', 'third', ${this.linkedid})`);
        },
    },
};
</script>

<style lang="scss">
.account-card {
    p {
        margin: 0;
    }
}
</style>
